import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  width: 100vw;
  justify-content: flex-start;
  gap: .7rem;
  margin-top: .5rem;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: .5rem;
  margin-top: .3rem;
`

export const ContainerInfo = styled.div`
  width: 100%;
  padding: 0 .4rem 0 .4rem;
`

export const ContainerType = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  padding: .5rem .3rem .7rem .3rem;
`

export const ContainerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 .4rem 0 .4rem;
  width: 100%;
  height: 2.5rem;
`

export const ContainerInput = styled.div`
  width: 100%;
  padding: 0 .4rem 0 .4rem;
`

export const CustomTextField = styled(TextFieldMui)`
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 .4rem .4rem;
  gap: .6rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;    
  height: 2.4rem !important;
  margin: 0 !important;
`

export const ModalProductNotFoundContainer = styled.span`
  display: flex;
  flex-direction: column;
  padding: .4rem;
`

export const ModalProductNotFoundText = styled.label`
  font-size: 15px;
`
